module.exports = __webpack_public_path__ + "media/images/user-base-ff5b85d6172889a69345e4a6defdacce.svg";